import React, { useContext } from 'react';
import AppContext from '../../context';
import { ContextName } from '../../appContext/contextName';
import { isMobileOrTablet } from '../../utils/browserDetection';
import { container } from './styles.module.css';

const MAX_EVENTS_DESKTOP = 5;
const MAX_EVENTS_MOBILE = 4;

const TileSet = ({ children }) => {
  const { [ContextName.USER_AGENT]: userAgent } = useContext(AppContext);

  const isMobile = isMobileOrTablet(userAgent);

  const tileToRender = children.slice(
    0,
    isMobile ? MAX_EVENTS_MOBILE : MAX_EVENTS_DESKTOP,
  );

  return <div className={container}>{tileToRender}</div>;
};

export default TileSet;
